
/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import ReactPlayer from "react-player";

interface Props {
  
}

function VideosSection({...props}: Props): JSX.Element {
  const vimeoVideoIds = [
    "817935071",
    "817944807",
    "817938625",
  ];
  return (
    <div
    {...props}
     style={{display:'flex', gap: 150}}>
      {vimeoVideoIds.map((id) => (
        <ReactPlayer url={`https://player.vimeo.com/video/${id}`} controls />
      ))}
    </div>
  );
}

export default VideosSection;
